<div   fxLayout="column"  fxLayoutAlign="center center" class="image-upload-wrapper">
    <p>{{title}}</p>
    <div class="image-wrapper">
        <img class="image-src" [src]="thumbnail" alt="" />   
        <p id="text-import" *ngIf="!thumbnail">Importer une image</p>       
        
    </div>    
    <button mat-mini-fab  >
        <mat-icon>edit</mat-icon>
        <input (change)="prepareForUpload($event, fileTarget)" type="file" [name]="fileTarget" />
    </button>  
</div>



